/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MeterSubCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MeterSubCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return MeterSubCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<MeterSubCategoryQueryOperator>): MeterSubCategoryQueryOperator {
        let obj = Object.assign(new MeterSubCategoryQueryOperator(), model);
        MeterSubCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MeterSubCategoryQueryOperator>): MeterSubCategoryQueryOperator {
        if (!model) return null;
        return MeterSubCategoryQueryOperator.newInstance(<MeterSubCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MeterSubCategoryQueryOperator) {
        if (!obj) return;

        models.MeterSubCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MeterSubCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MeterSubCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Meter sub categories to include
     */
    meter_sub_categories: Array<string>;

}
